// Standard log keys
// https://github.com/opentracing/specification/blob/4ceff7bff2e01ed8cdb277d4823709bce070750f/semantic_conventions.md#log-fields-table
export const ERROR_KIND = 'error.kind';
export const ERROR_OBJECT = 'error.object';
export const EVENT = 'event';
export const MESSAGE = 'message';
export const STACK = 'stack';
